import type { ReactNode } from 'react';

interface ActionButtonProps {
  label: string;
  onClick: () => void;
  icon: ReactNode;
  tone?: 'neutral' | 'info' | 'warning' | 'success' | 'danger';
}

const toneStyles: Record<NonNullable<ActionButtonProps['tone']>, string> = {
  neutral: 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900',
  info: 'border-sky-200 bg-sky-50 text-sky-700 hover:border-sky-300 hover:bg-sky-100',
  warning: 'border-amber-200 bg-amber-50 text-amber-700 hover:border-amber-300 hover:bg-amber-100',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-700 hover:border-emerald-300 hover:bg-emerald-100',
  danger: 'border-rose-200 bg-rose-50 text-rose-700 hover:border-rose-300 hover:bg-rose-100'
};

export function ActionButton({
  label,
  onClick,
  icon,
  tone = 'neutral'
}: ActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-xl border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-sky-500/30 focus:ring-offset-2 ${toneStyles[tone]}`}
    >
      <span className="h-4 w-4">{icon}</span>
    </button>
  );
}
